import { isPlainObject } from "lodash";
import invariant from "tiny-invariant";

type Serializable =
  | string
  | number
  | boolean
  | null
  | undefined
  | SerializableObject
  | SerializableArray;

interface SerializableObject {
  [key: string]: Serializable;
}

type SerializableArray = Serializable[];

const isRecord = (val: unknown): val is Record<string, unknown> =>
  typeof val === "object" && val !== null;

export const isSerializable = (value: unknown): value is Serializable => {
  if (
    value === undefined ||
    value === null ||
    typeof value === "boolean" ||
    typeof value === "number" ||
    typeof value === "string"
  ) {
    return true;
  }

  if (!isPlainObject(value) && !Array.isArray(value)) {
    return false;
  }

  if (!isRecord(value)) return false;
  return Object.values(value).every(isSerializable);
};

export const serializableInvariant = (value: unknown) => {
  invariant(isSerializable(value), "Value is not serializable");
};
